// One coordinator per filter/company selection. Rebuild the visible prefix so
// inserts and sort changes cannot shift an offset page into an older snapshot.
export const createAssignmentListController = ({ fetchPage, publish, pageSize = 50 }) => {
    let disposed = false;
    let busy = false;
    let dirty = false;
    let pages = 1;
    let hasMore = false;
    let initialized = false;

    const run = async (targetPages, initial = false) => {
        if (disposed) return;
        if (busy) { dirty = true; return; }
        busy = true;
        publish({ loading: initial, loadingMore: targetPages > pages, error: '' });
        try {
            let result;
            const rows = new Map();
            let loadedPages = 0;
            for (let page = 1; page <= targetPages; page++) {
                result = await fetchPage(page, pageSize);
                if (disposed) return;
                result.data.forEach(row => rows.set(row.id, row));
                loadedPages = page;
                if (!result.pagination.hasMore) break;
            }
            pages = loadedPages;
            hasMore = result.pagination.hasMore;
            initialized = true;
            publish({ data: [...rows.values()], pagination: { ...result.pagination, page: pages }, updated: new Date() });
        } catch (error) {
            if (!disposed) publish({ error: error.message || 'Unable to load assignments. Please retry.' });
        } finally {
            busy = false;
            if (!disposed) {
                publish({ loading: false, loadingMore: false });
                if (dirty) { dirty = false; await run(pages, !initialized); }
            }
        }
    };

    return {
        refresh: () => run(pages, !initialized),
        loadMore: () => {
            if (!busy && initialized && hasMore) return run(pages + 1);
        },
        dispose: () => { disposed = true; },
    };
};
